<template  >
  <v-layout column mt-4>
    <v-layout row wrap justify-space-between v-for="(reason, index) in selectedItems" :key="index">
        <div class="solicitation__select-btn-box">
          <button
            @click="removeItem(index)"
          >
            X
          </button>
        </div>
        <v-layout wrap class="solicitation__select-container">
          <v-flex xs12 md5 lg4>
              <select-field
                class="solicitation__select-item"
                :label="$t('labels.solicitationSelectReason')"
                required
                :rules="rule.required"
                v-model="selectedItems[index].reason"
                :items="reasonsIds"
              ></select-field>
          </v-flex>
          <v-flex xs12 md7 lg8 class="field-spacing">
            <select-multiple
              v-if="selectedItems[index].reason !== '' && showSubSelecte"
              label="Subitem"
              :value="selectedItems[index].subReasons"
              required
              :items="getSubreasons(selectedItems[index].reason)"
              :onCallback="changeSubReasons"
              :index="index"
            />
          </v-flex>
        </v-layout>
    </v-layout>
    <v-layout row wrap>
        <v-flex xs12>
            <label>Deseja adicionar mais itens?</label>
        </v-flex>
        <v-flex xs12>
            <v-btn
              v-on:click="addItems()"
              class="ma-2" tile color="#666666"
              dark >
                <v-icon left>bexsicon-plus</v-icon>Adicionar Itens
            </v-btn>
        </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import SelectMultiple from '@/components/fields/SelectMultiple';
import SelectField from '@/components/fields/Select';
export default {
  components: {
    SelectMultiple,
    SelectField
  },
  props: {
    onCallback: Function,
    value: Array,
    reasons: Array,
    previousReasons: Array
  },
  data() {
    return {
      selectedItems: this.value,
      showSubSelecte: true,
      test: false,
      warrantyExpiredMessage: this.$t('responses.solicitationOutWarranty'),
      previouslySelectedMessage: this.$t(
        'responses.solicitationReasonPreviouslySelected'
      )
    };
  },
  methods: {
    changeSubReasons(index, subitem) {
      this.selectedItems[index].subReasons = subitem;
      this.onCallback(this.selectedItems);
    },
    addItems() {
      this.selectedItems.push({
        reason: '',
        subReasons: [],
        hasExpiredReasons: false
      });
    },
    removeItem(index) {
      this.selectedItems.splice(index, 1);
    },
    verifySubReasons(subReason) {
      return subReason && !!subReason.length;
    },
    clearSubReasons(reason, selected) {
      if (selected && this.verifySubReasons(selected.subReasons)) {
        if (
          !reason.subReasons.find(
            item => item.id === selected.subReasons[0].value
          )
        ) {
          let index = this.selectedItems.indexOf(selected);
          this.showSubSelecte = false;
          this.selectedItems[index].subReasons = [];
        }
      }
      selected.hasExpiredReasons = reason.subReasons.some(
        subReason => !subReason.isWithinWarranty
      );
    },
    getSubreasons(id) {
      let reason = this.reasons.find(item => item.id === id);
      let selected = this.selectedItems.find(item => item.reason === id);
      if (reason) {
        this.clearSubReasons(reason, selected);
        return reason.subReasons.map(subReason => {
          const warrantyExpired = !subReason.isWithinWarranty;
          const previouslySelected = !!this.previousReasons.find(
            p => p.idSubReason === subReason.id
          );
          const disabledConf = {};
          disabledConf.disabled = warrantyExpired || previouslySelected;
          if (disabledConf.disabled) {
            disabledConf.disabledMessage = warrantyExpired
              ? this.warrantyExpiredMessage
              : previouslySelected
                ? this.previouslySelectedMessage
                : '';
            disabledConf.disabledWarningColor = previouslySelected
              ? '#0093f0'
              : '';
          }

          return {
            text: subReason.name,
            value: subReason.id,
            ...disabledConf
          };
        });
      } else {
        return [];
      }
    }
  },
  created() {
    this.selectedItems = this.value;
  },
  updated() {
    if (!this.showSubSelecte) {
      this.showSubSelecte = true;
    }
  },
  computed: {
    reasonsIds() {
      return this.reasons.map(reason => {
        return {
          text: reason.name,
          value: reason.id,
          disabled: !!this.selectedItems.find(item => reason.id === item.reason)
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/breakpoint';

.solicitation {
  &__select-btn-box {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    button {
      width: 20px;
      font-weight: bold;
    }
    button:hover {
      color: white;
      background-color: #0093f0;
      border-radius: 16px;
    }
  }
  // &__select-container {
  //   display: flex;
  //   width: 100%;
  // }
}

.ticket {
  &__input {
    border: 1px lightgray solid;
    border-radius: 5px;

    padding: 0px 0px 5px;

    &__error {
      border: 1px #ff5252 solid;
    }

    >>> .v-input__slot {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.02),
        0 1px 5px 0 rgba(0, 0, 0, 0.02) !important;

      textarea {
        margin: 0 !important;
      }
    }
  }
}
.field-spacing {
  @include breakpoint(not-mobile) {
    padding-left: 8px !important;
  }
  @include breakpoint(mobile) {
    padding-left: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/support/ticket/technicalAssistance/SolicitationStep.vue